var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.navShow),expression:"navShow"}],staticClass:"topNav"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/reservation"}},[_vm._v(_vm._s(_vm.$t('New Reservation')))])],1),_c('li',[_c('router-link',{attrs:{"to":"/orders/search"}},[_vm._v(_vm._s(_vm.$t('Reservation Search')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }